import { Tag } from "antd";
import ButtonMain from "components/ButtonMain";
import { ACCOUNT_STATUS, TIME_FORMAT } from "constants/index";
import dayjs from "dayjs";
import { ReactNode } from "react";
import * as S from "./style";

type Props = {
  status?: ACCOUNT_STATUS;
  time?: string;
  reason?: string;
  onClick?: (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    id: string
  ) => void;
};

function AccountStatus({
  status = ACCOUNT_STATUS.Initial,
  time,
  reason,
  onClick,
}: Props) {
  const mapStatus: Record<
    ACCOUNT_STATUS,
    {
      tag: { label: string; backgroundColor: string };
      timeString: string;
      buttons?: {
        id: "reject" | "approve" | "active" | "deactive";
        element: ReactNode[];
      }[];
    }
  > = {
    [ACCOUNT_STATUS.Initial]: {
      tag: {
        label: "Initial",
        backgroundColor: "#1F8EFF",
      },
      timeString: "Registered at",
    },
    [ACCOUNT_STATUS.Waiting]: {
      tag: {
        label: "승인 대기중",
        backgroundColor: "#FF900E",
      },
      timeString: "Verified email at",
      buttons: [
        {
          id: "reject",
          element: [<ButtonMain>거절</ButtonMain>],
        },
        {
          id: "approve",
          element: [<ButtonMain type="primary">승인</ButtonMain>],
        },
      ],
    },
    [ACCOUNT_STATUS.Reject]: {
      tag: {
        label: "Rejected",
        backgroundColor: "var(--hint-color)",
      },
      timeString: "Rejected at",
      buttons: [
        {
          id: "active",
          element: [<ButtonMain type="primary">Activate acc</ButtonMain>],
        },
      ],
    },
    [ACCOUNT_STATUS.Active]: {
      tag: {
        label: "활성",
        backgroundColor: "#4AA159",
      },
      timeString: "활성화 날짜",
      buttons: [
        {
          id: "deactive",
          element: [<ButtonMain>비활성화 하기</ButtonMain>],
        },
      ],
    },
    [ACCOUNT_STATUS.Inactive]: {
      tag: {
        label: "비활성",
        backgroundColor: "#BDBDBD",
      },
      timeString: "비활성화 날짜",
      buttons: [
        {
          id: "active",
          element: [<ButtonMain type="primary">활성화 하기</ButtonMain>],
        },
      ],
    },
  };

  const handleButtonClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    id: string
  ) => {
    if (onClick) {
      onClick(e, id);
    }
  };

  return (
    <S.Wrapper>
      <div className="left-container">
        <p className="title">계정 상태</p>
        <div>
          <Tag color={mapStatus[status].tag.backgroundColor}>
            {mapStatus[status].tag.label}
          </Tag>
          <p className="account-time">
            {`${mapStatus[status].timeString} ${
              time || dayjs(new Date()).format(TIME_FORMAT)
            }`}
          </p>
          {reason && <p className="account-reason">비활성 사유: {reason}</p>}
        </div>
      </div>
      <div className="right-container">
        {mapStatus[status].buttons?.map((x, i) => (
          <div
            key={x.id}
            onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
              handleButtonClick(e, x.id)
            }
          >
            {x.element.map((el, i) => (
              <div key={i}>{el}</div>
            ))}
            {/* {x.element} */}
          </div>
        ))}
      </div>
    </S.Wrapper>
  );
}

export default AccountStatus;
